/**
 * Socket.IO client — Sobeca
 * Singleton pour les notifications temps réel.
 */
import { io } from "socket.io-client";

const socket = io("/", {
  autoConnect: false,
  transports: ["websocket", "polling"],
  reconnectionAttempts: 5,
  reconnectionDelay: 2000,
});

socket.on("connect_error", (err) => {
  console.warn("Socket.IO connexion échouée:", err.message);
});

export default socket;
